interface IUrlGeneratorService<S extends IGenerateUrl> {
  addUrl: <NS extends IGenerateUrl>(x: NS) => IUrlGeneratorService<NS & S>;
  urlFor: S;
}

type IGenerateUrl = { [key: string]: (...args: any[]) => string };

const injectBaseUrl =
  (generateUrl: (...args: []) => string, baseUrl: string) =>
  (...args: []): string =>
    `${baseUrl}${generateUrl(...args)}`;

const injectBaseUrlIntoObject = <S extends IGenerateUrl>(generatorObject: S, baseUrl?: string): S => {
  let result = { ...generatorObject };
  for (const key of Object.keys(result)) {
    result = { ...result, [key]: injectBaseUrl(result[key], baseUrl || '') };
  }
  return result;
};

export const urlGeneratorService = <S extends IGenerateUrl>(urls: S, baseUrl?: string): IUrlGeneratorService<S> => {
  return {
    addUrl: <NS extends IGenerateUrl>(x: NS) =>
      urlGeneratorService({ ...urls, ...injectBaseUrlIntoObject(x, baseUrl) }, baseUrl),
    urlFor: urls,
  };
};
